import { db } from '@/firebase/init';
import { PermissionFromStore } from '@/types/types';
import { getWorkspacePermissionsPath } from '@/utils/queryPaths';
import { collection, orderBy, query } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirestoreCollection } from '../hooks/useFirestoreCollection';

function useWorkspacePermissions(workspaceId: string): PermissionFromStore[] {
  const permissionsQuery = useMemo(
    () =>
      query(
        collection(db, getWorkspacePermissionsPath(workspaceId)),
        orderBy('email', 'asc'),
      ),
    [workspaceId],
  );

  const permissions = useFirestoreCollection<PermissionFromStore>(
    ['workspacePermissions', workspaceId],
    permissionsQuery,
  );

  return permissions;
}

export { useWorkspacePermissions };
